import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, formatMoney } from "../Helpers";
import { STR_BUY_NOW, STR_CASH, STR_FLOAT, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBSCRIPTION_HAS_EXPIRED, STR_YOUR_REQUEST } from "../Strings";
import { MdCall, MdMessage, MdWhatsapp } from "react-icons/md";
import { FaMoneyBillTransfer, FaMoneyBillTrendUp } from "react-icons/fa6";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		appContext.navTo({
			item: "view",
			subItem: "agent_request",
			extraItem: data.id,
		});
	}

	return (
		<div
			className=""
			onClick={view}
			style={{
				padding: "10px",
			}}
		>
			<div className="d-flex mb-4">
				{
					(data.requestType === 'float') ?
					<>
						<FaMoneyBillTrendUp className="align-self-center text-primary" size={16}/>
						<span
							style={{
								fontSize: "14px",
								marginLeft: "5px"
							}}
							className="align-self-center font-bold text-primary"
						>
							{STR_FLOAT[appContext.language]}
						</span>
					</>
					
					:""
				}

				{
					(data.requestType === 'cash') ?
					<>
						<FaMoneyBillTransfer className="align-self-center text-secondary" size={16}/>
						<span
							style={{
								fontSize: "14px",
								marginLeft: "5px"
							}}
							className="align-self-center font-bold text-secondary"
						>
							{STR_CASH[appContext.language]}
						</span>
					</>
					
					:""
				}
			</div>
			<h6
				style={{
					fontSize: "20px",
				}}
				className="font-semi-bold"
			>
				TZS {formatMoney(data.amount)}
			</h6>
			<h6
				style={{
					fontSize: "18px"
				}}
			>
				{appContext.getTillTypeName(data.tillType)}
			</h6>

			{
				(Number(appContext.currentUserData.id) === Number(data.userId)) ?
				<span className="badge bg-secondary">{STR_YOUR_REQUEST[appContext.language]}</span>
				:""
			}

			<div className="text-end">
				<h6
					className="font-regular"
					style={{
						fontSize: "12px"
					}}
				>
					{formatDate(data.dateCreated)}
				</h6>
			</div>

			<hr/>
		</div>
	);
}
